import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CalendarIcon, SearchIcon, TagIcon } from 'lucide-react';
export function InsightsPage() {
  // Featured blog posts
  const featuredPosts = [{
    id: 1,
    title: 'Can You Include Amazon Affiliate Links in Emails?',
    slug: 'can-you-include-amazon-affiliate-links-in-emails',
    description: "Learn about Amazon's 2024 policy changes that now allow affiliate links in emails and how to implement them correctly to maximize your revenue.",
    date: 'July 22, 2025',
    image: "/ChatGPT_Image_Aug_22%2C_2025%2C_02_43_21_PM.png",
    category: 'Affiliate Marketing',
    author: 'Gavin Smith',
    authorImage: "/Gavin_Smith.png"
  },
  // Placeholder for future posts
  {
    id: 2,
    title: 'How AI Can Improve Your Newsletter Content Creation (Without Losing Your Voice)',
    slug: 'how-ai-can-improve-your-newsletter-content-creation',
    description: 'Discover how to use AI as a co-pilot for your newsletter creation process, streamlining workflows while maintaining your authentic voice and connection with readers.',
    date: 'August 5, 2025',
    image: "/ChatGPT_Image_Aug_22%2C_2025%2C_02_17_28_PM.png",
    category: 'AI & Content Creation',
    author: 'Gavin Smith',
    authorImage: "/Gavin_Smith.png"
  }, {
    id: 3,
    title: 'Monetization Strategies for Creator Newsletters in 2025',
    slug: 'monetization-strategies-for-creator-newsletters-in-2025',
    description: 'Explore effective monetization methods beyond subscriptions that newsletter creators are using to diversify revenue streams and build sustainable businesses.',
    date: 'July 8, 2025',
    image: "/ChatGPT_Image_Aug_22%2C_2025%2C_04_04_11_PM.png",
    category: 'Monetization',
    author: 'Gavin Smith',
    authorImage: "/c8a2c6e1-9da3-4061-9fe6-5a81b393c2c4.jpg"
  }];
  // Categories for filtering
  const categories = ['All Topics', 'Affiliate Marketing', 'AI & Technology', 'Monetization', 'Growth Strategies', 'Email Marketing'];
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1061">
      <Header data-id="element-1062" />
      <main className="flex-grow pt-36 pb-24" data-id="element-1063">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1064">
          {/* Hero Section */}
          <div className="mb-16 text-center" data-id="element-1065">
            <h1 className="font-serif text-5xl font-bold text-gray-900 mb-6" data-id="element-1066">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-1067">
                Insights
              </span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1068">
              Practical strategies and insights to help creators grow their
              audience, optimize monetization, and stay ahead with AI-powered
              tools.
            </p>
          </div>
          {/* Search and Filter Section */}
          <div className="mb-12" data-id="element-1069">
            <div className="flex flex-col md:flex-row gap-4 justify-between items-center" data-id="element-1070">
              <div className="relative w-full md:w-96" data-id="element-1071">
                <input type="text" placeholder="Search insights..." className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1072" />
                <SearchIcon className="absolute left-3 top-3.5 h-5 w-5 text-gray-400" data-id="element-1073" />
              </div>
              <div className="flex flex-wrap gap-2 w-full md:w-auto" data-id="element-1074">
                {categories.map((category, index) => <button key={index} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${index === 0 ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1075">
                    {category}
                  </button>)}
              </div>
            </div>
          </div>
          {/* Featured Post */}
          <div className="mb-16" data-id="element-1076">
            <Link to={`/insights/${featuredPosts[0].slug}`} className="block group" data-id="element-1077">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-1078">
                <div className="h-64 md:h-auto overflow-hidden" data-id="element-1079">
                  <img src={featuredPosts[0].image} alt={featuredPosts[0].title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-1080" />
                </div>
                <div className="p-8 flex flex-col justify-center" data-id="element-1081">
                  <div className="flex items-center mb-4" data-id="element-1082">
                    <TagIcon className="h-4 w-4 text-blue-600 mr-2" data-id="element-1083" />
                    <span className="text-sm font-medium text-blue-600" data-id="element-1084">
                      {featuredPosts[0].category}
                    </span>
                  </div>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors" data-id="element-1085">
                    {featuredPosts[0].title}
                  </h2>
                  <p className="text-gray-600 mb-6" data-id="element-1086">
                    {featuredPosts[0].description}
                  </p>
                  <div className="flex items-center text-gray-500" data-id="element-1087">
                    <CalendarIcon className="h-4 w-4 mr-2" data-id="element-1088" />
                    <span className="text-sm" data-id="element-1089">{featuredPosts[0].date}</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          {/* Blog Posts Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1090">
            {featuredPosts.slice(1).map(post => <Link key={post.id} to={`/insights/${post.slug}`} className="group" data-id="element-1091">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 h-full hover:shadow-lg transition-shadow" data-id="element-1092">
                  <div className="aspect-square overflow-hidden" data-id="element-1093">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-1094" />
                  </div>
                  <div className="p-6" data-id="element-1095">
                    <div className="flex items-center mb-3" data-id="element-1096">
                      <TagIcon className="h-4 w-4 text-blue-600 mr-2" data-id="element-1097" />
                      <span className="text-sm font-medium text-blue-600" data-id="element-1098">
                        {post.category}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors" data-id="element-1099">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3" data-id="element-1100">
                      {post.description}
                    </p>
                    <div className="flex items-center text-gray-500" data-id="element-1101">
                      <CalendarIcon className="h-4 w-4 mr-2" data-id="element-1102" />
                      <span className="text-sm" data-id="element-1103">{post.date}</span>
                    </div>
                  </div>
                </div>
              </Link>)}
          </div>
          {/* Newsletter Signup */}
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-8 md:p-12" data-id="element-1104">
            <div className="max-w-3xl mx-auto text-center" data-id="element-1105">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-1106">
                Get Insights Delivered to Your Inbox
              </h3>
              <p className="text-gray-600 mb-8" data-id="element-1107">
                Join our newsletter to receive the latest articles, tips, and
                strategies to help you grow as a creator.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-id="element-1108">
                <input type="email" placeholder="Enter your email" className="flex-grow px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1109" />
                <button className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1110">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1111" />
    </div>;
}